import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCookie } from "../../common/FetchCookie";

function EmpRegVerif() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", ""]);

  const moveToNext = (currentIndex, value) => {
    const newOtp = [...otp];
    newOtp[currentIndex] = value;
    setOtp(newOtp);

    if (value && currentIndex < 3) {
      document.getElementById(`digit${currentIndex + 2}`)?.focus();
    }
  };

  const [user, setUser] = useState(null);

  const fetchUser = async () => {
    try {
      const userData = await fetchCookie();
      // console.log("fetch", userData);
      setUser(userData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);
  const [showUserTypeSelection, setShowUserTypeSelection] = useState(false);


  // console.log("user", user)
  const handleVerify = () => {
    if (user?.user) {
      const userType = user.user?.user_type; // Ensure user_type exists
      if (userType === "candidate") {
        navigate("/candidate-profile");
      } else if (userType === "employer") {
        navigate("/employer-basics");
      }
    } else {
      setShowUserTypeSelection(true); // Show user type selection component
    }
  };
  
  const UserTypeSelection = ({ onSelect }) => {
    return (
      <div>
        <h3>Select Your Role</h3>
        <button onClick={() => onSelect("candidate")}>Candidate</button>
        <button onClick={() => onSelect("employer")}>Employer</button>
      </div>
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-10 rounded-2xl shadow-xl">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Verify Your Account
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            We've sent a 4-digit verification code to your mobile number
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleVerify}>
          <div className="rounded-md space-y-px">
            <div className="flex justify-between">
              {[0, 1, 2, 3].map((index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  id={`digit${index + 1}`}
                  value={otp[index]}
                  onChange={(e) => moveToNext(index, e.target.value)}
                  className="appearance-none relative block w-14 h-14 px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-xl text-center font-semibold transition-all duration-300 ease-in-out"
                  autoComplete="off"
                />
              ))}
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150 ease-in-out"
            >
              Verify OTP
            </button>
          </div>
        </form>
        {showUserTypeSelection && (
          <UserTypeSelection
            onSelect={(type) => {
              if (type === "candidate") {
                navigate("/candidate-profile");
              } else if (type === "employer") {
                navigate("/employer-basics");
              }
            }}
          />
        )}

        <div className="text-center">
          <p className="mt-2 text-sm text-gray-600">
            Didn't receive the code?{" "}
            <button
              onClick={() => {
                /* Implement resend logic here */
              }}
              className="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none transition duration-150 ease-in-out"
            >
              Resend OTP
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default EmpRegVerif;
